<template>
  <app-content>
    <step-by-step
      class="network-edit__step-by-step"
      ref="stepcmp"
      :steps="steps"
      :loading="loading"
      :current-step.sync="step"
      :conclude-button-text="$t('general.save')"
    >
      <network-data
        slot="content:network-data"
        @can-forward-changed="networkDataCanForward = $event"
      >
      </network-data>
      <network-parameterization
        slot="content:network-parameterization"
        @can-forward-changed="networkParameterizationDataCanForward = $event"
      >
      </network-parameterization>
      <module-parameterization
        slot="content:module-parameterization"
        @can-forward-changed="networkParameterizationDataCanForward = $event"
      >
      </module-parameterization>
      <template slot="bottomPreviousPanel">
        <b-button v-if="canCancel" variant="secondary" @click="cancel()">
          {{ $t('general.cancel') }}
        </b-button>
      </template>
    </step-by-step>
  </app-content>
</template>

<script>
import StepByStep from '@/components/stepByStep/index';
import NetworkData from '@/domain/components/generalPanel/networkManagement/editing/NetworkData';
import NetworkParameterization from '@/domain/components/generalPanel/networkManagement/editing/NetworkParameterization';
import ModuleParameterization from '@/domain/components/generalPanel/networkManagement/editing/ModuleParameterization';

export default {
  name: 'NewNetwork',
  components: {
    StepByStep,
    NetworkData,
    NetworkParameterization,
    ModuleParameterization,
  },
  data() {
    return {
      loading: false,
      step: null,
      networkDataCanForward: true,
      networkParameterizationDataCanForward: true,
      steps: [
        {
          labelPath: 'network-manager.editing.network-data.title',
          icon: 'fas fa-info-circle',
          name: 'network-data',
          canForward: () => this.networkDataCanForward,
          onForward: () => this.onForwardNetworkData(),
        },
        {
          name: 'network-parameterization',
          labelPath: 'network-manager.editing.network-parameterization.title',
          icon: 'fas fa-bezier-curve',
          canForward: () => this.networkParameterizationDataCanForward,
        },
        {
          name: 'module-parameterization',
          labelPath: 'network-manager.editing.module-parameterization.title',
          icon: 'fas fa-box',
        },
      ],
    };
  },
  methods: {
    onForwardNetworkData() {
      return true;
    },
    goToNetworkList() {
      this.$router.push({
        name: 'network-management',
      });
    },
    cancel() {
      this.$confirmMessage({
        code: 'MC006',
      }).accepted(() => this.goToNetworkList());
    },
  },
  computed: {
    canCancel() {
      return this.step === 0;
    },
  },
};
</script>

<style lang="sass" scoped>
@import src/styles/defaults/variables
@import "src/styles/defaults/mobile-first"

.network-edit
  &__step-by-step
    flex: 1
    +media-min-sm()
    +media-min-md()
    +media-min-lg()
</style>
